import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { SupportLinkContent } from 'src/app/content/content.models';
import { ContentService } from 'src/app/content/content.service';
import { AppUser } from 'src/app/shared/models/app-user';
import {SchedulerConfig, VolatileAppSettingsDto} from 'src/app/services/api.services';
import { select, Store } from '@ngrx/store';
import * as AppSelectors from 'src/app/state/app/app.selectors';
import { AppActions } from '../../state/app';

@Component({
  selector: 'app-layout-default-shell',
  template: `<app-layout-default
    [layoutParams]="layoutParams"
    [user]="user"

    (logout)="logout.emit()"

    [insightsLibraryVisible]="insightsLibraryVisible"
    (openInsightsLibrary)="openInsightsLibrary.emit()"

    [schedulerConfig] = "schedulerConfig$ | async"

    [supportLinks] = "supportLinks$ | async"

    [features]="features$ | async"
  ><ng-content></ng-content></app-layout-default>
  `,
  standalone: false
})
export class LayoutDefaultShellComponent implements OnInit, OnChanges {
  constructor(
    private readonly contentService: ContentService,
    private readonly store: Store) {
  }

  @Input() layoutParams: any;
  @Input() user: AppUser;

  @Output() logout = new EventEmitter();

  @Input() insightsLibraryVisible = false;
  @Output() openInsightsLibrary = new EventEmitter();

  supportLinks$: Observable<SupportLinkContent[]>;

  @Input() schedulerConfig$: Observable<SchedulerConfig>;

  features$ = this.store.select(AppSelectors.getFeatures);

  ngOnInit() {
    this.schedulerConfig$ = this.store.pipe(select(AppSelectors.schedulerConfig));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user) {
      if (!!this.user) {
        this.supportLinks$ = this.contentService.supportLinks$.pipe(
          map(c => this.user ? c?.links?.filter(l => !l.hidden && (!l.role || this.user.role >= l.role)) : [])
        );
      }
    }
  }
}
